import React, { Component } from 'react';

// Routes
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  fetchNotifications
} from '../../modules/notification';

import { listInvitations } from '../../modules/reader';

import { authUtil } from '../../utils';
import AppIcon from '../../components/AppIcon';

import NotificationsList from './notificationsList';
import InvitationsSubMenuItem from './invitationsSubMenuItem';
import InvitationsList from './invitationsList';

export class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.menuRef = React.createRef();
  }

  componentDidMount() {
    const { notifications } = this.props;
    if (!notifications || notifications.length === 0) {
      this.fetchNotifications();
    }
    this.fetchInvitations();
  }

  fetchNotifications = async () => {
    const { notifications } = this.props;
    let after;
    if (notifications && notifications.length > 0) {
      // get the timestamp of the freshest notification
      after = new Date(notifications[0].createdAt).getTime();
    }
    const idToken = await authUtil.getFreshIdToken();
    this.props.fetchNotifications(idToken, { after });
  }

  fetchInvitations = async () => {
    const idToken = await authUtil.getFreshIdToken();
    this.props.listInvitations(idToken);
  }

  showInvitations = () => {
    this.setState({ showInvitations: true });
  }

  onToggle = (event) => {
    if (event.currentTarget.open) {
      this.fetchNotifications();
      this.hideInvitations();
      this.fetchInvitations();
    }
  }

  hideInvitations = (event) => {
    if (event) event.stopPropagation();
    this.setState({ showInvitations: false });
  }

  closeMenu = () => {
    if (this.menuRef.current) this.menuRef.current.open = false;
  }

  render() {
    const {
      t, unreadCount, loadingNotifications, invitations
    } = this.props;
    const { showInvitations } = this.state;
    const totalUnreadCount = (unreadCount || 0) + (Array.isArray(invitations) ? invitations.length : 0);

    return (
      <details ref={this.menuRef} onToggle={this.onToggle} style={{ position: 'relative' }}>
        <summary aria-label={t('Notifications')} style={{
          listStyle: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center',
          justifyContent: 'center', gap: 'var(--br-space-1)', padding: 'var(--br-space-2)',
          minWidth: 44, minHeight: 44, boxSizing: 'border-box'
        }}>
          <AppIcon name={loadingNotifications ? 'spinner' : 'bell'} loading={loadingNotifications} aria-hidden="true" />
          {totalUnreadCount > 0 && <span className='br-chip' style={{ margin: 0 }}>
            {totalUnreadCount}
          </span>}
        </summary>
        <div style={{
          position: 'absolute', right: 0, zIndex: 20,
          width: 'min(70vw, 560px)', minWidth: 'min(320px, 90vw)',
          maxHeight: '400px', overflowY: 'auto',
          background: 'var(--br-surface)', border: '1px solid var(--br-border)',
          borderRadius: 'var(--br-control-radius)'
        }}>
            {
              !showInvitations && invitations && invitations.length > 0 && (
                <InvitationsSubMenuItem invitations={invitations} onSelect={this.showInvitations} />
              )
            }
            {
              showInvitations && invitations && invitations.length > 0
                ? <InvitationsList />
                : <NotificationsList onClose={this.closeMenu} />
            }
        </div>
      </details>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  unreadCount: state.notification.unreadCount,
  notifications: state.notification.notifications,
  invitations: state.reader.invitations,
  loadingInvitations: state.reader.loadingInvitations,
  loadingNotifications: state.notification.loadingNotifications
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchNotifications,
  listInvitations,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications)));
